export const REGULATORY_ACCEPT = 'REGULATORY_ACCEPT';
export const LOADED_CONSENT_REQUEST = 'LOADED_CONSENT_REQUEST';
export const OAUTH_LOGO_UPDATE = 'OAUTH_LOGO_UPDATE';
export const OAUTH_UPDATE_DEVICE_APPNAME = 'OAUTH_UPDATE_DEVICE_APPNAME';

export interface OauthState {
  appLogo: string;
  appName?: string;
  client?: OauthClient;
  agreements?: string[];
  requestedScopes: string[];
  scopeDetails?: OauthScopeDetails;
}

interface OauthLogoUpdateAction {
  type: typeof OAUTH_LOGO_UPDATE;
  appLogo: string;
}

interface LoadedConsentRequestAction {
  type: typeof LOADED_CONSENT_REQUEST;
  client: OauthClient;
  agreements?: string[];
  requestedScopes: string[];
  scopeDetails: OauthScopeDetails;
}

interface LoadedRegulatoryAcceptAction {
  type: typeof REGULATORY_ACCEPT;
  agreements?: string[];
}

interface OauthAppNameUpdateAction {
  type: typeof OAUTH_UPDATE_DEVICE_APPNAME;
  appName: string;
}

export type OauthActions =
  | LoadedConsentRequestAction
  | LoadedRegulatoryAcceptAction
  | OauthLogoUpdateAction
  | OauthAppNameUpdateAction;
